(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6682"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6682"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gs4Ta", function(module, exports) {
/**
 * What the dialog layer looks like, in one file.
 *
 * The same field was typed out in four places and the same button in three,
 * each a long Tailwind string that nobody would diff against the others. That
 * is how a border ends up slate-300 in one dialog and gray-300 in the next, and
 * why the toast looked like it came from a different site than the dialog it
 * replaced.
 *
 * Everything visual that more than one file needs lives here. A file that needs
 * something once still keeps it local: this is a vocabulary, not a stylesheet.
 */ /** The card every surface in this layer is made of. */ const $bfa30db1b2721b24$var$SURFACE = 'rounded-2xl bg-white shadow-2xl ring-1 ring-slate-900/5 dark:bg-gray-800 dark:ring-white/10';
/** A text input, a textarea, a select. */ const $bfa30db1b2721b24$var$FIELD = "w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 placeholder-slate-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-slate-500";
/** The label above one. */ const $bfa30db1b2721b24$var$LABEL = 'mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300';
/** The quiet line under one. */ const $bfa30db1b2721b24$var$HINT = 'mt-1 text-xs text-slate-500 dark:text-slate-400';
const $bfa30db1b2721b24$var$BUTTON = "inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 dark:focus-visible:ring-offset-gray-800";
/**
 * Three tones, and only three. An arbitrary colour is how a codebase ends up
 * with two different reds that mean the same thing.
 */ const $bfa30db1b2721b24$var$TONES = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 focus-visible:ring-blue-500',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500',
    neutral: "bg-white text-slate-700 ring-1 ring-inset ring-slate-300 hover:bg-slate-50 focus-visible:ring-slate-400 dark:bg-gray-800 dark:text-slate-200 dark:ring-gray-600 dark:hover:bg-gray-700"
};
/**
 * The chip that says what kind of message this is.
 *
 * The same five in the dialog and in the toast, so that a saved file looks like
 * a saved file whichever of the two it arrives in.
 */ const $bfa30db1b2721b24$var$CHIPS = {
    success: {
        icon: 'fa-check',
        wrap: 'bg-emerald-100 text-emerald-600 dark:bg-emerald-500/15 dark:text-emerald-400'
    },
    error: {
        icon: 'fa-xmark',
        wrap: 'bg-red-100 text-red-600 dark:bg-red-500/15 dark:text-red-400'
    },
    warning: {
        icon: 'fa-triangle-exclamation',
        wrap: 'bg-amber-100 text-amber-600 dark:bg-amber-500/15 dark:text-amber-400'
    },
    info: {
        icon: 'fa-info',
        wrap: 'bg-blue-100 text-blue-600 dark:bg-blue-500/15 dark:text-blue-400'
    },
    question: {
        icon: 'fa-question',
        wrap: 'bg-slate-100 text-slate-500 dark:bg-gray-700 dark:text-slate-300'
    }
};
/**
 * @param {string} tag
 * @param {string} [className]
 * @param {string} [text]
 * @returns {HTMLElement}
 */ function $bfa30db1b2721b24$var$el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = String(text);
    return node;
}
/**
 * @param {string} [tone] - a key of CHIPS
 * @param {string} [size] - 'md' for a dialog, 'sm' for a toast
 * @returns {HTMLElement|null} null when the tone is not one we draw
 */ function $bfa30db1b2721b24$var$chip(tone, size) {
    const found = $bfa30db1b2721b24$var$CHIPS[tone];
    if (!found) return null;
    const box = size === 'sm' ? 'h-7 w-7 text-xs' : 'h-10 w-10';
    const wrap = $bfa30db1b2721b24$var$el('div', 'flex shrink-0 items-center justify-center rounded-lg ' + box + ' ' + found.wrap);
    wrap.appendChild($bfa30db1b2721b24$var$el('i', 'fa-solid ' + found.icon));
    return wrap;
}
module.exports = {
    SURFACE: $bfa30db1b2721b24$var$SURFACE,
    FIELD: $bfa30db1b2721b24$var$FIELD,
    LABEL: $bfa30db1b2721b24$var$LABEL,
    HINT: $bfa30db1b2721b24$var$HINT,
    BUTTON: $bfa30db1b2721b24$var$BUTTON,
    TONES: $bfa30db1b2721b24$var$TONES,
    CHIPS: $bfa30db1b2721b24$var$CHIPS,
    el: $bfa30db1b2721b24$var$el,
    chip: $bfa30db1b2721b24$var$chip
};

});

parcelRegister("7teUa", function(module, exports) {
/**
 * A short message in the corner, for what does not warrant a dialog.
 *
 * This existed twice, once in admin/core.js and once in biolink-editor.js, as
 * two nearly identical copies that had drifted in their timings. It is one
 * implementation now, and it brings its own stack when the page has none: the
 * admin layout and the biolink editor render a #toastStack, every other page
 * does not, and a toast that silently does nothing outside those two is a bug
 * waiting for whoever moves a call.
 */ 
var $gs4Ta = parcelRequire("gs4Ta");
var $5706cd9f79eb41f6$require$SURFACE = $gs4Ta.SURFACE;
var $5706cd9f79eb41f6$require$el = $gs4Ta.el;
var $5706cd9f79eb41f6$require$chip = $gs4Ta.chip;
// How long a toast stays. Two values, not eight: the call sites used to each
// pick a number between 1.2 and 4 seconds, and the difference between 1400 and
// 1500 was never meant by anyone. What does matter is that something that went
// wrong stays long enough to read.
const $5706cd9f79eb41f6$var$VISIBLE_MS = 2800;
const $5706cd9f79eb41f6$var$PROBLEM_MS = 4500;
const $5706cd9f79eb41f6$var$FADE_MS = 220;
/**
 * The container, made if it is not already in the layout.
 * @returns {HTMLElement}
 */ function $5706cd9f79eb41f6$var$stack() {
    let node = document.getElementById('toastStack');
    if (!node) {
        node = document.createElement('div');
        node.id = 'toastStack';
        node.className = 'pointer-events-none fixed bottom-4 right-4 z-[100] flex flex-col items-end gap-2';
        document.body.appendChild(node);
    }
    // A live region, so a toast is read out and not only seen. Also set on the
    // stacks the admin layout and the biolink editor render themselves.
    if (!node.hasAttribute('aria-live')) {
        node.setAttribute('role', 'status');
        node.setAttribute('aria-live', 'polite');
    }
    return node;
}
// Made when the page loads rather than with the first toast: a live region
// that appears together with its message is not announced, so the first toast
// on a page would otherwise be the one nobody hears.
if (typeof document !== 'undefined') {
    if (document.body) $5706cd9f79eb41f6$var$stack();
    else document.addEventListener('DOMContentLoaded', $5706cd9f79eb41f6$var$stack);
}
/**
 * @param {string} message
 * @param {string} [kind] - success, error, warning or info
 * @param {number} [duration] - milliseconds, when this one has a reason to
 *   differ. Left out, the kind decides.
 * @param {Object} [action] - { label, run } for one button inside the toast,
 *   an Undo for instance. Pressing it closes the toast and calls `run`. A
 *   toast with an action stays until its duration is up, so pass a duration
 *   long enough to reach the button.
 * @returns {HTMLElement} the toast, with a `close()` method
 */ function $5706cd9f79eb41f6$var$toast(message, kind, duration, action) {
    // The same card and the same chip as a dialog, in small. A message used to
    // look like one thing when it arrived as a solid coloured pill and like
    // another when the same words arrived in a dialog.
    const node = $5706cd9f79eb41f6$require$el('div', "pointer-events-auto flex max-w-sm translate-y-2 items-center gap-3 px-3 py-2.5 text-sm text-slate-700 opacity-0 transition-all duration-200 dark:text-slate-200 " + $5706cd9f79eb41f6$require$SURFACE);
    const mark = $5706cd9f79eb41f6$require$chip(kind || 'info', 'sm');
    if (mark) node.appendChild(mark);
    // textContent, because a message can carry a file name or a username.
    node.appendChild($5706cd9f79eb41f6$require$el('span', 'min-w-0', message));
    let closed = false;
    let timer = null;
    node.close = function() {
        if (closed) return;
        closed = true;
        clearTimeout(timer);
        node.classList.add('translate-y-2', 'opacity-0');
        setTimeout(function() {
            if (node.parentNode) node.parentNode.removeChild(node);
        }, $5706cd9f79eb41f6$var$FADE_MS);
    };
    if (action && action.label) {
        const button = $5706cd9f79eb41f6$require$el('button', "ml-1 shrink-0 rounded-md px-2 py-1 text-sm font-semibold text-blue-700 transition hover:bg-blue-50 dark:text-blue-300 dark:hover:bg-blue-500/10", action.label);
        button.type = 'button';
        button.addEventListener('click', function() {
            node.close();
            if (typeof action.run === 'function') action.run();
        });
        node.appendChild(button);
    }
    $5706cd9f79eb41f6$var$stack().appendChild(node);
    const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : (fn)=>setTimeout(fn, 16);
    raf(function() {
        node.classList.remove('translate-y-2', 'opacity-0');
    });
    timer = setTimeout(node.close, duration || (kind === 'error' || kind === 'warning' ? $5706cd9f79eb41f6$var$PROBLEM_MS : $5706cd9f79eb41f6$var$VISIBLE_MS));
    return node;
}
module.exports = {
    toast: $5706cd9f79eb41f6$var$toast
};

});

/**
 * The dialog and toast layer, as a global.
 *
 * Six pages call these from inline scripts in EJS and cannot import anything,
 * and the bundles that can import are spread across the site, so one script in
 * the header is what everything shares. It replaces the SweetAlert plugin that
 * used to sit in that slot.
 *
 * Two doors, on purpose:
 *
 *   window.ui   what this is. ui.confirm, ui.alert, ui.prompt, ui.toast, and
 *               ui.dialog underneath them for anything with its own shape.
 *               New code uses these.
 *
 *   window.Swal the option names the 87 existing calls already pass, mapped
 *               onto the same dialog. It exists so that dropping the plugin did
 *               not have to mean rewriting all of them on one afternoon. See
 *               ui/swal.js; it goes when the last call site has moved.
 */ var $23b011fdf8e74ac3$exports = {};
/**
 * The SweetAlert shaped front door onto our own dialog.
 *
 * 87 calls in 15 files use `Swal.fire`, six of them inline in EJS pages that
 * cannot import anything. Rewriting all of them in one go to drop a plugin
 * would be a change nobody could review, so this speaks the same language: the
 * options those calls already pass, and a result object with the same shape.
 * The dialog underneath is ours (see dialog.js), and call sites can move to it
 * one at a time, or never.
 *
 * Only what the call sites actually use is implemented. The full plugin has
 * three times this surface, and an option nobody passes is an option nobody
 * needs to maintain. Unknown options are ignored rather than refused, so a
 * forgotten one degrades into a plainer dialog instead of a broken page.
 *
 * Two behaviours are worth knowing because they are subtle and both appear in
 * this codebase:
 *
 *   preConfirm returning undefined means "take the input value", not "take
 *   nothing". Several call sites validate and fall off the end of the function.
 *
 *   A validation message put up during preConfirm keeps the dialog open, even
 *   when the handler returns nothing. Half the call sites say `return false`
 *   and the other half rely on the message alone.
 */ var $6df37559b98f8ea2$exports = {};
/**
 * The modal dialog the site uses.
 *
 * Built on the native <dialog> element, which is the whole point: it brings the
 * focus trap, Escape, the backdrop and the top layer with it. Those four are
 * what hand written modals get wrong, and getting them wrong means a dialog a
 * keyboard cannot leave or one that renders behind the navbar.
 *
 * The shape is the one the rest of the site uses for a card: an icon chip and a
 * heading on one line, the text under it, the buttons on a footer of their own
 * with the primary one on the right where a desktop expects it. Left aligned,
 * because that is how everything else here reads.
 *
 * This layer knows nothing about where its options come from. It takes a title,
 * a body element and a list of buttons, and answers with the button that was
 * pressed. The translation from the option names the call sites use lives next
 * door in swal.js.
 */ 
var $gs4Ta = parcelRequire("gs4Ta");
var $6df37559b98f8ea2$require$SURFACE = $gs4Ta.SURFACE;
var $6df37559b98f8ea2$require$BUTTON = $gs4Ta.BUTTON;
var $6df37559b98f8ea2$require$TONES = $gs4Ta.TONES;
var $6df37559b98f8ea2$require$el = $gs4Ta.el;
/**
 * m-auto is not decoration. Tailwind's reset sets margin: 0 on every element,
 * which takes out the margin: auto that the user agent uses to centre a modal
 * dialog in the top layer, and the dialog ends up in the top left corner.
 */ const $6df37559b98f8ea2$var$SHELL = 'm-auto w-[calc(100%-2rem)] max-w-lg bg-transparent p-0 backdrop:bg-slate-900/70';
// A column, so that a dialog taller than the screen scrolls its middle and
// keeps the heading and the buttons where they are. The plugin scrolled the
// whole popup, buttons and all, which is how a confirm button ends up below
// the fold on a phone.
const $6df37559b98f8ea2$var$PANEL = 'flex max-h-[85dvh] w-full flex-col overflow-hidden text-left ' + $6df37559b98f8ea2$require$SURFACE;
let $6df37559b98f8ea2$var$sequence = 0;
/**
 * Open a dialog.
 *
 * @param {Object} spec
 * @param {string} [spec.title]
 * @param {Node} [spec.icon] - the chip beside the title
 * @param {Node} [spec.body] - everything between the heading and the buttons.
 *   An element that already sits in the page is borrowed rather than taken: it
 *   goes back where it was when the dialog closes. Without that, a form the
 *   page renders once and shows in a dialog several times is in the document
 *   for the first open and gone for every one after, and the second open fails
 *   on a getElementById that used to work.
 * @param {Array<{id: string, label: string, tone?: string, autofocus?: boolean}>} [spec.buttons]
 *   A button is one of the three tones and nothing else: an arbitrary colour is
 *   how a codebase ends up with two reds that mean the same thing.
 *   In reading order, so the last one sits on the right.
 * @param {boolean|Function} [spec.dismissable=true] - whether a click on the
 *   backdrop closes it, and whether the corner button is offered at all.
 * @param {boolean|Function} [spec.escapable=true] - the same for Escape. Kept
 *   apart from the backdrop because they are different promises to the person
 *   using it: a dialog that ignores a stray click is fine, one that cannot be
 *   escaped is a trap.
 * @param {string} [spec.width]
 * @param {HTMLElement} [spec.focus] - what to focus instead of a button
 * @param {Function} [spec.onAction] - (id, controller) before closing. Return
 *   false, or a promise of false, to keep the dialog open. Anything else is
 *   handed back as the result value.
 * @param {Function} [spec.onOpen] - (controller) once it is on screen
 * @returns {Object} the controller
 */ function $6df37559b98f8ea2$var$openDialog(spec) {
    const options = spec || {};
    const buttons = options.buttons || [
        {
            id: 'confirm',
            label: 'OK',
            tone: 'primary',
            autofocus: true
        }
    ];
    const dialog = $6df37559b98f8ea2$require$el('dialog', $6df37559b98f8ea2$var$SHELL);
    dialog.setAttribute('aria-modal', 'true');
    if (options.width) dialog.style.maxWidth = options.width;
    const panel = $6df37559b98f8ea2$require$el('div', $6df37559b98f8ea2$var$PANEL);
    dialog.appendChild(panel);
    // ── Head: chip, heading, and the way out ────────────────────────────────
    const head = $6df37559b98f8ea2$require$el('div', 'flex shrink-0 items-start gap-3 px-6 pt-6');
    if (options.icon) head.appendChild(options.icon);
    const headText = $6df37559b98f8ea2$require$el('div', 'min-w-0 flex-1');
    if (options.title) {
        $6df37559b98f8ea2$var$sequence += 1;
        const heading = $6df37559b98f8ea2$require$el('h2', 'text-base font-semibold text-slate-900 dark:text-white', options.title);
        heading.id = 'dialog-title-' + $6df37559b98f8ea2$var$sequence;
        dialog.setAttribute('aria-labelledby', heading.id);
        headText.appendChild(heading);
    }
    head.appendChild(headText);
    const dismiss = $6df37559b98f8ea2$require$el('button', "js-dialog-dismiss -mr-2 -mt-2 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-600 dark:hover:bg-gray-700 dark:hover:text-slate-200");
    dismiss.type = 'button';
    dismiss.setAttribute('aria-label', 'Close');
    dismiss.appendChild($6df37559b98f8ea2$require$el('i', 'fa-solid fa-xmark'));
    head.appendChild(dismiss);
    panel.appendChild(head);
    // ── Body ────────────────────────────────────────────────────────────────
    // ui-scroll is in app.css: a scrollbar in the theme's colours rather than
    // the platform's, which on a dark panel means a light bar in the dark.
    const content = $6df37559b98f8ea2$require$el('div', 'ui-scroll overflow-y-auto px-6 pb-2 pt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-300');
    if (options.icon) content.className += ' sm:pl-[4.25rem]'; // line up under the heading
    // Where a borrowed body has to be put back, see the note on spec.body.
    const bodyHome = options.body && options.body.parentNode ? options.body.parentNode : null;
    if (options.body) content.appendChild(options.body);
    panel.appendChild(content);
    // Hidden until something is wrong, and announced when it appears: a message
    // that only changes colour is no message at all for a screen reader.
    const validation = $6df37559b98f8ea2$require$el('p', "mx-6 mb-2 mt-2 hidden shrink-0 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700 dark:bg-red-900/20 dark:text-red-300");
    validation.setAttribute('role', 'alert');
    panel.appendChild(validation);
    // Only for the dialogs that work without a button to spin inside.
    const spinner = $6df37559b98f8ea2$require$el('div', 'hidden items-center gap-2 px-6 pb-2 text-sm text-slate-500 dark:text-slate-400');
    spinner.appendChild($6df37559b98f8ea2$require$el('i', 'fa-solid fa-circle-notch fa-spin'));
    spinner.appendChild($6df37559b98f8ea2$require$el('span', '', 'Working...'));
    panel.appendChild(spinner);
    // ── Footer ──────────────────────────────────────────────────────────────
    const footer = $6df37559b98f8ea2$require$el('div', "mt-4 flex shrink-0 flex-wrap items-center justify-end gap-2 border-t border-slate-200 bg-slate-50 px-6 py-4 dark:border-white/10 dark:bg-gray-900/40");
    panel.appendChild(footer);
    const byId = {};
    let settle = null;
    let closed = false;
    let loading = false;
    const controller = {
        element: dialog,
        panel: panel,
        body: content,
        result: new Promise((resolve)=>{
            settle = resolve;
        }),
        /** @returns {HTMLElement|null} */ button (id) {
            return byId[id] || null;
        },
        /**
         * Everything off while something is in flight. The spinner goes inside
         * the primary button when there is one, so the dialog does not change
         * size at the moment the person is waiting on it.
         */ setLoading (on) {
            loading = Boolean(on);
            Object.keys(byId).forEach((id)=>{
                byId[id].disabled = loading;
            });
            dismiss.disabled = loading;
            const primary = byId.confirm || byId[Object.keys(byId)[0]];
            if (primary) // Built with the button and only shown, so nothing has to be
            // inserted into a live dialog.
            primary.spinner.style.display = loading ? '' : 'none';
            else {
                spinner.classList.toggle('hidden', !loading);
                spinner.classList.toggle('flex', loading);
            }
        },
        isLoading () {
            return loading;
        },
        /** @param {string|null} message */ setValidation (message) {
            if (message) {
                validation.textContent = message;
                validation.classList.remove('hidden');
            } else {
                validation.textContent = '';
                validation.classList.add('hidden');
            }
        },
        hasValidation () {
            return !validation.classList.contains('hidden');
        },
        /**
         * @param {string|null} action - the button id, or null when nothing was pressed
         * @param {Object} [extra] - { reason, value }
         */ close (action, extra) {
            if (closed) return;
            closed = true;
            // Before the dialog is taken apart, or the body goes with it.
            if (bodyHome && options.body) bodyHome.appendChild(options.body);
            if (typeof dialog.close === 'function' && dialog.open) dialog.close();
            if (dialog.parentNode) dialog.parentNode.removeChild(dialog);
            settle({
                action: action || null,
                reason: extra && extra.reason || (action ? 'action' : 'dismiss'),
                value: extra ? extra.value : undefined
            });
        }
    };
    /**
     * @param {string} name - 'dismissable' or 'escapable'
     * @returns {boolean}
     */ function allows(name) {
        const value = options[name];
        if (typeof value === 'function') return Boolean(value());
        return value !== false;
    }
    buttons.forEach((button)=>{
        const node = $6df37559b98f8ea2$require$el('button', $6df37559b98f8ea2$require$BUTTON + ' ' + ($6df37559b98f8ea2$require$TONES[button.tone] || $6df37559b98f8ea2$require$TONES.neutral));
        node.type = 'button';
        node.dataset.action = button.id;
        // Hidden with an inline style rather than the hidden class. Font
        // Awesome loads after Tailwind and sets display on .fa-solid at the
        // same specificity, so .hidden loses and every button would sit there
        // spinning. An inline style beats both stylesheets and cannot lose that
        // argument later either.
        node.spinner = $6df37559b98f8ea2$require$el('i', 'fa-solid fa-circle-notch fa-spin');
        node.spinner.style.display = 'none';
        node.appendChild(node.spinner);
        node.appendChild($6df37559b98f8ea2$require$el('span', '', button.label));
        node.addEventListener('click', function() {
            if (loading) return;
            controller.setValidation(null);
            if (typeof options.onAction !== 'function') {
                controller.close(button.id);
                return;
            }
            const outcome = options.onAction(button.id, controller);
            Promise.resolve(outcome).then(function(value) {
                // False keeps it open, and so does a validation message the
                // handler put up on its way out: both are ways of saying "not
                // like that", and call sites use each of them.
                if (value === false || controller.hasValidation()) {
                    controller.setLoading(false);
                    return;
                }
                controller.close(button.id, {
                    value: value
                });
            });
        });
        byId[button.id] = node;
        footer.appendChild(node);
    });
    // The corner button is a dismissal, the same as Escape. It is hidden rather
    // than removed when a dialog refuses to be dismissed, so the heading keeps
    // the same width either way.
    dismiss.classList.toggle('hidden', !allows('dismissable') && !allows('escapable'));
    dismiss.addEventListener('click', function() {
        if (!loading) controller.close(null, {
            reason: 'close'
        });
    });
    // Escape. The native event is cancelable, which is the only way to refuse a
    // dismissal without taking the key over entirely.
    dialog.addEventListener('cancel', function(event) {
        event.preventDefault();
        if (!loading && allows('escapable')) controller.close(null, {
            reason: 'esc'
        });
    });
    // A click on the backdrop reaches the dialog itself, never the panel.
    dialog.addEventListener('click', function(event) {
        if (event.target !== dialog) return;
        if (!loading && allows('dismissable')) controller.close(null, {
            reason: 'backdrop'
        });
    });
    document.body.appendChild(dialog);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', 'open'); // stubs and very old browsers
    const marked = buttons.find((b)=>b.autofocus);
    const target = options.focus || marked && byId[marked.id];
    if (target && typeof target.focus === 'function') target.focus();
    if (typeof options.onOpen === 'function') options.onOpen(controller);
    return controller;
}
$6df37559b98f8ea2$exports = {
    openDialog: $6df37559b98f8ea2$var$openDialog,
    el: $6df37559b98f8ea2$require$el
};


var $23b011fdf8e74ac3$require$openDialog = $6df37559b98f8ea2$exports.openDialog;

var $7teUa = parcelRequire("7teUa");
var $23b011fdf8e74ac3$require$toast = $7teUa.toast;

var $gs4Ta = parcelRequire("gs4Ta");
var $23b011fdf8e74ac3$require$FIELD = $gs4Ta.FIELD;
var $23b011fdf8e74ac3$require$LABEL = $gs4Ta.LABEL;
var $23b011fdf8e74ac3$require$el = $gs4Ta.el;
var $23b011fdf8e74ac3$require$chip = $gs4Ta.chip;
const $23b011fdf8e74ac3$var$INPUT_TYPES = [
    'text',
    'email',
    'password',
    'number',
    'url',
    'tel',
    'search'
];
// The dialog on screen, for the statics that reach for it from outside.
let $23b011fdf8e74ac3$var$current = null;
/**
 * Whatever was passed as `html`, as something that can be appended.
 *
 * Three shapes turn up, and the plugin took all three: a string of markup, a
 * DOM node, and a jQuery object. The folder dialog in dashboard.js builds its
 * fields in jQuery and hands over the element, which a version of this that
 * only did strings rendered as the text "[object HTMLDivElement]".
 *
 * @param {string|Node|Object} value
 * @returns {Node}
 */ function $23b011fdf8e74ac3$var$htmlNode(value) {
    if (value && value.nodeType) return value;
    // A jQuery object, or anything else array-like holding a node.
    if (value && typeof value === 'object' && value[0] && value[0].nodeType) return value[0];
    const wrap = $23b011fdf8e74ac3$require$el('div', '');
    wrap.innerHTML = String(value); // our own markup, never user input
    return wrap;
}
/**
 * The input, when one was asked for.
 * @returns {HTMLElement|null}
 */ function $23b011fdf8e74ac3$var$inputNode(options) {
    if (!options.input) return null;
    const wrap = $23b011fdf8e74ac3$require$el('div', 'mt-4 text-left');
    if (options.inputLabel) wrap.appendChild($23b011fdf8e74ac3$require$el('label', $23b011fdf8e74ac3$require$LABEL, options.inputLabel));
    const isArea = options.input === 'textarea';
    const field = $23b011fdf8e74ac3$require$el(isArea ? 'textarea' : 'input', $23b011fdf8e74ac3$require$FIELD);
    if (isArea) field.rows = 4;
    else field.type = $23b011fdf8e74ac3$var$INPUT_TYPES.indexOf(options.input) === -1 ? 'text' : options.input;
    if (options.inputPlaceholder) field.placeholder = options.inputPlaceholder;
    if (options.inputValue !== undefined && options.inputValue !== null) field.value = String(options.inputValue);
    if (options.inputAttributes && typeof options.inputAttributes === 'object') Object.keys(options.inputAttributes).forEach(function(name) {
        field.setAttribute(name, options.inputAttributes[name]);
    });
    // Enter in a single line field means confirm, the way it does in a form.
    if (!isArea) field.addEventListener('keydown', function(event) {
        if (event.key !== 'Enter' || !$23b011fdf8e74ac3$var$current) return;
        event.preventDefault();
        const confirm = $23b011fdf8e74ac3$var$current.button('confirm');
        if (confirm && !confirm.disabled) confirm.click();
    });
    wrap.appendChild(field);
    wrap.__field = field;
    return wrap;
}
/**
 * The buttons, left to right.
 *
 * The plugin put the confirm button first, on the left. Here the way out is on
 * the left and the thing you came to do is on the right, which is where every
 * other desktop dialog puts it and where the mouse already is after reading.
 *
 * @returns {Array}
 */ function $23b011fdf8e74ac3$var$buttonsFor(options) {
    const buttons = [];
    if (options.showCancelButton) buttons.push({
        id: 'cancel',
        label: options.cancelButtonText || 'Cancel',
        tone: 'neutral'
    });
    if (options.showDenyButton) buttons.push({
        id: 'deny',
        label: options.denyButtonText || 'No',
        tone: 'danger'
    });
    if (options.showConfirmButton !== false) buttons.push({
        id: 'confirm',
        label: options.confirmButtonText || 'OK',
        tone: $23b011fdf8e74ac3$var$isDestructive(options.confirmButtonColor) ? 'danger' : 'primary',
        // A destructive default should be reached for, not landed on.
        autofocus: options.focusConfirm !== false && !options.input && !$23b011fdf8e74ac3$var$isDestructive(options.confirmButtonColor)
    });
    return buttons;
}
/**
 * Whether this is a message that dismisses itself rather than a question.
 * @returns {boolean}
 */ function $23b011fdf8e74ac3$var$selfClosing(config) {
    return Boolean(config.timer) && config.showConfirmButton === false && !config.input && !config.html;
}
/**
 * One line out of a title and a text that were written for two.
 * @returns {string}
 */ function $23b011fdf8e74ac3$var$toastMessage(config) {
    const title = (config.title || '').trim();
    const text = (config.text || '').trim();
    if (!title) return text;
    if (!text) return title;
    return /[.!?:]$/.test(title) ? title + ' ' + text : title + ': ' + text;
}
/**
 * Whether a colour was asking for the destructive button.
 *
 * Call sites pass '#d33' and '#dc2626' for the same intent, neither of which is
 * the red the rest of the site uses. Rather than paint the button with whatever
 * arrived, the intent is read off it and the site's own destructive style is
 * used, so every dangerous button looks the same.
 *
 * @param {string} [color]
 * @returns {boolean}
 */ function $23b011fdf8e74ac3$var$isDestructive(color) {
    const hex = String(color || '').trim().replace('#', '');
    if (hex.length !== 3 && hex.length !== 6) return false;
    const full = hex.length === 3 ? hex.split('').map((c)=>c + c).join('') : hex;
    const red = parseInt(full.slice(0, 2), 16);
    const green = parseInt(full.slice(2, 4), 16);
    const blue = parseInt(full.slice(4, 6), 16);
    if ([
        red,
        green,
        blue
    ].some(Number.isNaN)) return false;
    return red > 120 && red > green * 1.6 && red > blue * 1.6;
}
/**
 * The result object, in the shape the call sites destructure.
 * @returns {Object}
 */ function $23b011fdf8e74ac3$var$resultFrom(outcome, fallbackValue) {
    const base = {
        isConfirmed: false,
        isDenied: false,
        isDismissed: false,
        value: undefined
    };
    if (outcome.action === 'confirm') {
        base.isConfirmed = true;
        base.value = outcome.value !== undefined ? outcome.value : fallbackValue;
        return base;
    }
    if (outcome.action === 'deny') {
        base.isDenied = true;
        base.value = false;
        return base;
    }
    base.isDismissed = true;
    base.dismiss = outcome.action === 'cancel' ? 'cancel' : outcome.reason || 'cancel';
    return base;
}
/**
 * Open a dialog.
 *
 * @param {Object} options - the SweetAlert options this codebase uses
 * @returns {Promise<Object>} { isConfirmed, isDenied, isDismissed, value, dismiss }
 */ function $23b011fdf8e74ac3$var$fire(options) {
    const config = options || {};
    // A toast is not a dialog: nothing is blocked, nothing is answered.
    //
    // Twenty two call sites open a modal with a timer and no buttons, in eight
    // different durations, to say things like "Copied!". That is a toast that
    // took the page hostage for 1.2 seconds, so it becomes one. Nothing about
    // the call has to change, and the answer stays the shape it was.
    if (config.toast || $23b011fdf8e74ac3$var$selfClosing(config)) {
        // The timer the caller passed is deliberately dropped: see toast.js,
        // which decides how long something stays from what kind of thing it is.
        $23b011fdf8e74ac3$require$toast($23b011fdf8e74ac3$var$toastMessage(config), config.icon);
        return Promise.resolve({
            isConfirmed: false,
            isDenied: false,
            isDismissed: true,
            dismiss: 'timer'
        });
    }
    const body = document.createDocumentFragment();
    if (config.html) body.appendChild($23b011fdf8e74ac3$var$htmlNode(config.html));
    else if (config.text) body.appendChild($23b011fdf8e74ac3$require$el('p', '', config.text));
    const input = $23b011fdf8e74ac3$var$inputNode(config);
    if (input) body.appendChild(input);
    const field = input ? input.__field : null;
    const readValue = ()=>field ? field.value : true;
    const controller = $23b011fdf8e74ac3$require$openDialog({
        title: config.title,
        icon: $23b011fdf8e74ac3$require$chip(config.icon),
        body: body,
        width: config.width,
        buttons: $23b011fdf8e74ac3$var$buttonsFor(config),
        focus: field,
        dismissable: function() {
            if (typeof config.allowOutsideClick === 'function') return Boolean(config.allowOutsideClick());
            return config.allowOutsideClick !== false;
        },
        // Kept apart from the backdrop, the way the plugin has it: a dialog that
        // refuses a stray click still lets a keyboard out.
        escapable: config.allowEscapeKey !== false,
        onAction: function(id) {
            if (id !== 'confirm' || typeof config.preConfirm !== 'function') return id === 'confirm' ? readValue() : undefined;
            if (config.showLoaderOnConfirm) controller.setLoading(true);
            return Promise.resolve(config.preConfirm(readValue())).then(function(value) {
                if (value === false) return false;
                // Undefined means the handler only looked; the input value is
                // still what the caller asked for.
                return value === undefined ? readValue() : value;
            }).catch(function(err) {
                controller.setValidation(err && err.message ? err.message : String(err));
                return false;
            });
        },
        onOpen: function(ctl) {
            $23b011fdf8e74ac3$var$current = ctl;
            if (typeof config.didOpen === 'function') config.didOpen(ctl.panel);
        }
    });
    if (config.timer) setTimeout(function() {
        controller.close(null, {
            reason: 'timer'
        });
    }, config.timer);
    return controller.result.then(function(outcome) {
        if ($23b011fdf8e74ac3$var$current === controller) $23b011fdf8e74ac3$var$current = null;
        return $23b011fdf8e74ac3$var$resultFrom(outcome, readValue());
    });
}
/** Close whatever is open, as a dismissal. */ function $23b011fdf8e74ac3$var$close() {
    if ($23b011fdf8e74ac3$var$current) $23b011fdf8e74ac3$var$current.close(null, {
        reason: 'close'
    });
}
/** Buttons off, spinner on, for work that started without a preConfirm. */ function $23b011fdf8e74ac3$var$showLoading() {
    if ($23b011fdf8e74ac3$var$current) $23b011fdf8e74ac3$var$current.setLoading(true);
}
/** @returns {boolean} */ function $23b011fdf8e74ac3$var$isLoading() {
    return Boolean($23b011fdf8e74ac3$var$current && $23b011fdf8e74ac3$var$current.isLoading());
}
/**
 * Put a message under the body and keep the dialog open.
 * @param {string} message
 */ function $23b011fdf8e74ac3$var$showValidationMessage(message) {
    if ($23b011fdf8e74ac3$var$current) {
        $23b011fdf8e74ac3$var$current.setLoading(false);
        $23b011fdf8e74ac3$var$current.setValidation(message);
    }
}
/** @returns {HTMLElement|null} */ function $23b011fdf8e74ac3$var$getConfirmButton() {
    return $23b011fdf8e74ac3$var$current ? $23b011fdf8e74ac3$var$current.button('confirm') : null;
}
/** @returns {HTMLElement|null} the panel, which is what didOpen hands out */ function $23b011fdf8e74ac3$var$getPopup() {
    return $23b011fdf8e74ac3$var$current ? $23b011fdf8e74ac3$var$current.panel : null;
}
$23b011fdf8e74ac3$exports = {
    fire: $23b011fdf8e74ac3$var$fire,
    close: $23b011fdf8e74ac3$var$close,
    showLoading: $23b011fdf8e74ac3$var$showLoading,
    isLoading: $23b011fdf8e74ac3$var$isLoading,
    showValidationMessage: $23b011fdf8e74ac3$var$showValidationMessage,
    getConfirmButton: $23b011fdf8e74ac3$var$getConfirmButton,
    getPopup: $23b011fdf8e74ac3$var$getPopup
};



var $ce22466278cd0a11$require$openDialog = $6df37559b98f8ea2$exports.openDialog;
var $67d3430ad816bfe1$exports = {};
/**
 * The three questions this site actually asks, as three functions.
 *
 * The plugin's option bag could express a hundred dialogs, and the code used it
 * to build the same four over and over, each spelled slightly differently. This
 * is what those four look like when they are named instead of configured:
 *
 *   ui.alert   here is something you should know
 *   ui.confirm are you sure, yes or no
 *   ui.prompt  type something, or do not
 *
 * They answer with what the caller actually wants, a boolean or a string or
 * nothing, rather than a result object to pick apart. New code should use
 * these; ui/swal.js stays for the calls that have not moved yet.
 */ 
var $67d3430ad816bfe1$require$openDialog = $6df37559b98f8ea2$exports.openDialog;

var $gs4Ta = parcelRequire("gs4Ta");
var $67d3430ad816bfe1$require$FIELD = $gs4Ta.FIELD;
var $67d3430ad816bfe1$require$LABEL = $gs4Ta.LABEL;
var $67d3430ad816bfe1$require$el = $gs4Ta.el;
var $67d3430ad816bfe1$require$chip = $gs4Ta.chip;
/** @returns {Node|null} */ function $67d3430ad816bfe1$var$textBody(text) {
    return text ? $67d3430ad816bfe1$require$el('p', '', text) : null;
}
/**
 * Something to read and acknowledge.
 *
 * @param {Object} options - { title, text, tone, closeLabel }
 * @returns {Promise<void>}
 */ function $67d3430ad816bfe1$var$alert(options) {
    const config = options || {};
    return $67d3430ad816bfe1$require$openDialog({
        title: config.title,
        icon: $67d3430ad816bfe1$require$chip(config.tone),
        body: $67d3430ad816bfe1$var$textBody(config.text),
        buttons: [
            {
                id: 'confirm',
                label: config.closeLabel || 'OK',
                tone: 'primary',
                autofocus: true
            }
        ]
    }).result.then(function() {});
}
/**
 * Yes or no.
 *
 * @param {Object} options - { title, text, tone, confirmLabel, cancelLabel, danger }
 * @returns {Promise<boolean>}
 */ function $67d3430ad816bfe1$var$confirm(options) {
    const config = options || {};
    return $67d3430ad816bfe1$require$openDialog({
        title: config.title,
        icon: $67d3430ad816bfe1$require$chip(config.tone || (config.danger ? 'warning' : 'question')),
        body: $67d3430ad816bfe1$var$textBody(config.text),
        buttons: [
            {
                id: 'cancel',
                label: config.cancelLabel || 'Cancel',
                tone: 'neutral'
            },
            {
                id: 'confirm',
                label: config.confirmLabel || 'Confirm',
                tone: config.danger ? 'danger' : 'primary',
                autofocus: !config.danger // a destructive default should be reached for, not landed on
            }
        ]
    }).result.then((outcome)=>outcome.action === 'confirm');
}
/**
 * Ask for one value.
 *
 * `validate` runs on the way out and may return a message to show instead of
 * closing, or a promise of one, which is how a prompt that has to check
 * something with the server stays open while it does.
 *
 * @param {Object} options - { title, text, label, placeholder, value, multiline,
 *   tone, confirmLabel, cancelLabel, validate }
 * @returns {Promise<string|null>} null when it was dismissed
 */ function $67d3430ad816bfe1$var$prompt(options) {
    const config = options || {};
    const body = document.createDocumentFragment();
    if (config.text) body.appendChild($67d3430ad816bfe1$require$el('p', 'mb-3', config.text));
    if (config.label) body.appendChild($67d3430ad816bfe1$require$el('label', $67d3430ad816bfe1$require$LABEL, config.label));
    const field = $67d3430ad816bfe1$require$el(config.multiline ? 'textarea' : 'input', $67d3430ad816bfe1$require$FIELD);
    if (config.multiline) field.rows = 4;
    if (config.placeholder) field.placeholder = config.placeholder;
    if (config.value) field.value = String(config.value);
    body.appendChild(field);
    const controller = $67d3430ad816bfe1$require$openDialog({
        title: config.title,
        icon: $67d3430ad816bfe1$require$chip(config.tone),
        body: body,
        focus: field,
        buttons: [
            {
                id: 'cancel',
                label: config.cancelLabel || 'Cancel',
                tone: 'neutral'
            },
            {
                id: 'confirm',
                label: config.confirmLabel || 'Save',
                tone: 'primary'
            }
        ],
        onAction: function(id, ctl) {
            if (id !== 'confirm') return undefined;
            if (typeof config.validate !== 'function') return field.value;
            ctl.setLoading(true);
            return Promise.resolve(config.validate(field.value)).then(function(message) {
                ctl.setLoading(false);
                if (!message) return field.value;
                ctl.setValidation(String(message));
                return false;
            });
        }
    });
    if (!config.multiline) field.addEventListener('keydown', function(event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        const button = controller.button('confirm');
        if (button && !button.disabled) button.click();
    });
    return controller.result.then((outcome)=>outcome.action === 'confirm' ? outcome.value : null);
}
$67d3430ad816bfe1$exports = {
    alert: $67d3430ad816bfe1$var$alert,
    confirm: $67d3430ad816bfe1$var$confirm,
    prompt: $67d3430ad816bfe1$var$prompt
};


var $ce22466278cd0a11$require$alert = $67d3430ad816bfe1$exports.alert;
var $ce22466278cd0a11$require$confirm = $67d3430ad816bfe1$exports.confirm;
var $ce22466278cd0a11$require$prompt = $67d3430ad816bfe1$exports.prompt;

var $7teUa = parcelRequire("7teUa");
var $ce22466278cd0a11$require$toast = $7teUa.toast;
window.ui = {
    alert: $ce22466278cd0a11$require$alert,
    confirm: $ce22466278cd0a11$require$confirm,
    prompt: $ce22466278cd0a11$require$prompt,
    toast: $ce22466278cd0a11$require$toast,
    dialog: $ce22466278cd0a11$require$openDialog
};
window.Swal = $23b011fdf8e74ac3$exports;
/**
 * The two behaviours that used to be `onclick` and `onchange` attributes.
 *
 * They were the last inline handlers in the templates, and an inline handler is
 * inline script: as long as four of them existed, `script-src` had to carry
 * 'unsafe-inline', and that one keyword undoes most of what a Content-Security
 * -Policy is for. Both are one line of behaviour attached to markup, so they
 * become attributes that name the behaviour and one delegated listener each.
 *
 * Delegated from the document rather than bound per element, so that markup
 * rendered after this runs works too, and so this costs two listeners on a page
 * regardless of how many controls use it.
 */ document.addEventListener('click', (event)=>{
    const trigger = event.target.closest('[data-toggle]');
    if (!trigger) return;
    const target = document.getElementById(trigger.getAttribute('data-toggle'));
    if (target) target.classList.toggle('hidden');
});
document.addEventListener('change', (event)=>{
    const control = event.target.closest('[data-submit-on-change]');
    if (control && control.form) control.form.submit();
});

})();
//# sourceMappingURL=ui.dc4539cc.js.map
